import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import "rxjs/add/operator/filter";
import { HttpClient } from "@angular/common/http";
@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit {
  utm_source: string;
  constructor(private route: ActivatedRoute, private router: Router, private http: HttpClient) {
    this.route.queryParams
      .filter((params) => params.utm_source)
      .subscribe((params) => {

        this.utm_source = params.utm_source;
        console.log(this.utm_source); // popular
        if (this.utm_source == "phonepe") {
          localStorage.setItem("utm_sources", JSON.stringify(this.utm_source));
          console.log(JSON.parse(localStorage.getItem("utm_sources")));

          window.scrollTo(0, 0);
        }
      });
  }

  ngOnInit() {
    // let x = "/orderdetail/10799?utm_source=phonepe"
    // this.router.navigate([x])
    this.getLocation()

  }
  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: Position) => {
        if (position) {
          console.log("Latitude: " + position.coords.latitude +
            "Longitude: " + position.coords.longitude);
          // this.lat = position.coords.latitude;
          // this.lng = position.coords.longitude;
          // console.log(this.lat);
          // console.log(this.lat);
          this.getLocationData(position.coords.latitude, position.coords.longitude)
        }
      },
        (error: PositionError) => console.log(error));
    } else {
      // alert("Geolocation is not supported by this browser.");
    }
  }
  getLocationData(latitude, longitude) {

    this.http.get('https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=' + latitude + '&longitude=' + longitude + '&localityLanguage=en',).subscribe(
      (data: any) => {
        console.log(data)
        // this.response = data;
        // //  this.hideLoader()
        // console.log(this.response)
        // Bhubaneswar(M.Corp.)
        if (data.localityInfo.administrative[3].name = "Bhubaneswar(M.Corp.)") {
          // alert("deliverable.....")
        }
        else {
          // alert("not deliverable")
        }
      },
      (error: any) => {
        alert("Can't connect to network,please make sure Mobile data is On");
        window.location.href = ""
        console.log("error")
      });
  }


}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/home/home.component.ts